import { httpClient } from '../../config';

export const fetchUniqueEventNames = async () => {
    try {
        const { json } = await httpClient('/tables/active_entities/unique_event_names');
        return json;
    } catch (error) {
        console.error('Failed to fetch goals data:', error);
        throw error;
    }
};
